import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=6dd31e01&scoped=true"
import script from "./combination.vue?vue&type=script&lang=js"
export * from "./combination.vue?vue&type=script&lang=js"
import style0 from "./combination.vue?vue&type=style&index=0&id=6dd31e01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd31e01",
  null
  
)

export default component.exports